import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "_heading-2" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "_text-gray" }
const _hoisted_4 = { class: "ml-3" }
const _hoisted_5 = { class: "_text-gray" }
const _hoisted_6 = { class: "p-button ml-6" }
const _hoisted_7 = { class: "_heading-2" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "_text-gray" }
const _hoisted_10 = { class: "p-button ml-6" }
const _hoisted_11 = { class: "grid" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("rect", {
  width: "1920",
  height: "1440",
  fill: "#ECEDF3"
}, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "flex mb-2" }
const _hoisted_15 = { class: "flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "py-4" }, {
      left: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_1, _toDisplayString($setup.photosStoreState.data.name), 1),
          _createElementVNode("span", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('photos_page.photos')), 1),
            _createTextVNode(": " + _toDisplayString($setup.photosStoreState.data.photos_count), 1)
          ]),
          _createElementVNode("span", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('photos_page.processed_photos')), 1),
            _createTextVNode(": " + _toDisplayString($setup.photosStoreState.data.processed_photos_count), 1)
          ])
        ]),
        _createElementVNode("label", _hoisted_6, [
          _createElementVNode("input", {
            type: "file",
            name: "",
            id: "",
            disabled: false,
            class: "p-upload-input",
            multiple: "",
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.uploadFile && $setup.uploadFile(...args)))
          }, null, 32),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('vehicles_page.upload_photo')), 1)
        ]),
        _createVNode(_component_Button, {
          onClick: $setup.download,
          class: "p-button-outlined p-button-gray p-button-only-icon ml-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Icon, { name: "download" })
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      right: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('photos_page.markup')), 1),
          _createElementVNode("span", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('photos_page.count')), 1),
            _createTextVNode(": " + _toDisplayString($setup.photosStoreState.data.datasets.length), 1)
          ])
        ]),
        _createElementVNode("label", _hoisted_10, [
          _createElementVNode("input", {
            type: "file",
            name: "",
            multiple: "",
            id: "",
            disabled: false,
            class: "p-upload-input",
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.datasetUpload && $setup.datasetUpload(...args)))
          }, null, 32),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('photos_page.upload_markup')), 1)
        ]),
        _createVNode(_component_Button, {
          onClick: $setup.datasetDownload,
          disabled: !$setup.photosStoreState.data.datasets.length,
          class: "p-button-outlined p-button-gray p-button-only-icon ml-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Icon, { name: "download" })
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_11, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.photosStoreState.data.photos.data, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col-3",
          key: item.id
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.card)
          }, [
            (_openBlock(), _createElementBlock("svg", {
              class: _normalizeClass([_ctx.$style.substrate, "_img-base"]),
              width: "1920",
              height: "1440",
              viewBox: "0 0 1920 1440",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, _hoisted_13, 2)),
            _withDirectives(_createElementVNode("img", {
              class: _normalizeClass(["_img-base", _ctx.$style.img]),
              alt: ""
            }, null, 2), [
              [_directive_lazy, item.thumbnail]
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.loading)
            }, [
              _createVNode(_component_ProgressSpinner)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.checkboxGroup)
            }, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('photos_page.selected_to_download')), 1),
                _createVNode(_component_Checkbox, {
                  class: _normalizeClass([_ctx.$style.checkbox, "ml-auto"]),
                  modelValue: item.isSelected,
                  "onUpdate:modelValue": ($event: any) => ((item.isSelected) = $event),
                  value: item.id,
                  binary: true
                }, null, 8, ["class", "modelValue", "onUpdate:modelValue", "value"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('photos_page.processed')), 1),
                _createVNode(_component_Checkbox, {
                  class: _normalizeClass([_ctx.$style.checkbox, "ml-auto"]),
                  onChange: $setup.markProcessed,
                  disabled: item.processed && !item.can_remove_mark,
                  modelValue: item.processed,
                  "onUpdate:modelValue": ($event: any) => ((item.processed) = $event),
                  value: item.id,
                  binary: true
                }, null, 8, ["class", "onChange", "disabled", "modelValue", "onUpdate:modelValue", "value"])
              ])
            ], 2)
          ], 2)
        ]))
      }), 128))
    ]),
    _createVNode(_component_Paginator, {
      currentPage: $setup.photosStoreState.data.photos.current_page || _ctx.$route.query.page || 1,
      total: $setup.photosStoreState.data.photos.total,
      lastPage: $setup.photosStoreState.data.photos.last_page,
      perPage: $setup.photosStoreState.data.photos.perPage,
      count: $setup.photosStoreState.data.photos.to
    }, null, 8, ["currentPage", "total", "lastPage", "perPage", "count"])
  ], 64))
}